<div class="h-full grid grid-rows-[max-content_auto_max-content]">
  <div class="border-b border-b-neutral-200 px-5 py-4">
    <p class="text-xl font-semibold">
      {{ title }}
    </p>
  </div>

  <div class="py-4 px-5 h-full">
    <ng-content select="[body]"></ng-content>
  </div>

  <div class="border-t border-b-neutral-200 px-5 py-4">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
